<template>
  <div class="global-menu">
    <div
      class="global-menu-li"
      v-for="(item, index) in tabList"
      :key="item.name"
      @click="handleRouter(item, index)"
      :class="{ 'global-menu-start': item.children.length > 0 }"
    >
      <template v-if="item.url">
        <div class="global-menu-li-title">
          {{ item.title }}
        </div>
      </template>
      <template v-else-if="item.children.length === 0" >
        <div class="global-menu-li-title" :class="{active:$route.name===item.name}">
          {{ item.title }}
        </div>
      </template>
      <template v-else-if="item.children.length > 0">
        <div class="global-menu-li-many">
          <span>{{ item.title }}</span>
          <img
            src="@/assets/img/drop-down.png"
            alt=""
            class="global-menu-li-drop"
            v-if="!item.show"
          />
          <img
            src="@/assets/img/drop-up.png"
            alt=""
            class="global-menu-li-drop"
            v-else
          />
        </div>
        <ul
          class="global-menu-li-list"
          v-if="item.show"
          :style="{ height: item.children.length * 70+ 'px' }"
        >
          <li
            :class="{active:$route.name===sub.name}"
            v-for="(sub, subIndex) in item.children"
            :key="subIndex"
            @click="handleRouter(sub, subIndex, 2)"
          >
            {{ sub.title }}
          </li>
        </ul>
      </template>
    </div>
    <div class="global-menu-bottom"></div>
  </div>
</template>
<script>
import { getNewsdetail } from "@/api";
import { SettingOutlined } from "@ant-design/icons-vue";
export default {
  name: "GlobalMenu",
  components: {},
  data() {
    return {
      isShow: false,
      index: 1,
      content: "",
      pageName: "首页",
      tabList: [
        {
          name: "首页",
          id: 1,
          title: "首页",
          url: "",
          children: [],
        },
        {
          name: "院务公开",
          id: 2,
          show: false,
          title: "院务公开",
          url: "",
          children: [
            {
              name: "医院概况",
              id: 21,
              title: "医院简介",
              url: "",
            },
            {
              name: "领导班子",
              id: 22,
              title: "领导班子",
              url: "",
            },
            {
              name: "组织机构",
              id: 23,
              title: "组织机构",
              url: "",
            },
            {
              name: "信息公开",
              id: 25,
              title: "信息公开",
              url: "",
            },
            {
              name: "环境设备",
              id: 24,
              title: "环境设备",
              url: "",
            },
          ],
        },
        {
          name: "新闻中心",
          id: 3,
          show: false,
          title: "新闻中心",
          url: "",
          children: [
            {
              name: "医院动态",
              id: 25,
              title: "医院动态",
              url: "",
            },
            {
              name: "通知公告",
              id: 26,
              title: "通知公告",
              url: "",
            },
            {
              name: "新闻视频",
              id: 27,
              title: "新闻视频",
              url: "",
            },
          ],
        },
        {
          name: "党风廉政",
          id: 4,
          show: false,
          title: "党风廉政",
          url: "",
          children: [
            {
              name: "党风廉政",
              id: 28,
              title: "党群动态",
              url: "",
            },
            {
              name: "廉政建设",
              id: 29,
              title: "廉政建设",
              url: "",
            },
          ],
        },
        {
          name: "学科建设",
          id: 5,
          show: false,
          title: "学科建设",
          url: "",
          children: [
            {
              name: "学科建设",
              id: 30,
              title: "科室介绍",
              url: "",
            },
            {
              name: "专家介绍",
              id: 31,
              title: "专家介绍",
              url: "",
            },
            {
              name: "技术优势",
              id: 32,
              title: "技术优势",
              url: "",
            },
            {
              name: "名中医工作室",
              id: "",
              title: "名中医工作室",
              url: "http://mzy.sxakzy.com.cn/",
            },
          ],
        },
        {
          name: "医疗管理",
          id: 6,
          show: false,
          title: "医疗管理",
          url: "",
          children: [],
        },
        {
          name: "护理天地",
          id: 7,
          show: false,
          title: "护理天地",
          url: "",
          children: [],
        },
        {
          name: "科研教学",
          id: 8,
          show: false,
          title: "科研教学",
          url: "",
          children: [
            {
              name: "科研教学",
              id: 33,
              title: "科研教学动态",
              url: "",
            },
             {
              name: "进修申请",
              id: 34,
              title: "进修申请",
              url: "",
            },
            {
              name: "规范化培训",
              id: 34,
              title: "住院医师规范化培训",
              url: "",
            },
            {
              name: "伦理平台",
              id: "",
              title: "伦理平台",
              url: "http://mzy.sxakzy.com.cn/llwyh/",
            },
            {
              name: "国家药物临床试验机构",
              id: "",
              title: "国家药物临床试验机构",
              url: "http://mzy.sxakzy.com.cn/ywlcsy/",
            },
          ],
        },
        {
          name: "健康教育",
          id: 9,
          show: false,
          title: "健康教育",
          url: "",
          children: [],
        },
        {
          name: "服务患者",
          id: 10,
          show: false,
          title: "就医指南",
          url: "",
          children: [],
        },
        {
          name: "高新院区",
          id: "",
          show: false,
          title: "高新院区",
          url: "",
          children: [],
        },
        {
          name: "联系我们",
          id: 11,
          show: false,
          title: "联系我们",
          url: "",
          children: [
            {
              name: "联系我们",
              id: 35,
              title: "联系地址",
              url: "",
            },
            {
              name: "在线留言",
              id: 36,
              title: "在线留言",
              url: "",
            },
          ],
        },
      ],
    };
  },
  created() {
    let url = window.location.href;
    let pos = url.lastIndexOf("/");
    let no = url.slice(pos + 1);
    this.index = Number(no);
  },
  methods: {
    async getNewsdetail() {
      const params = {
        id: this.$route.params.id,
      };
      getNewsdetail(params).then((res) => {
        this.pageName = res.data.name;
      });
    },
    //跳转路由
    handleRouter(item, index, type = 1) {
      if (this.$route.name !== item.name) {
        //没有子节点时
        if (type === 1) {
          if (item.url) {
            window.open(item.url, "_blank");
            this.$store.commit("SETMENUSTATE", false);
          } else if (item.children.length === 0 && !item.url) {
            this.$router.push({
              name: item.name,
              params: {
                id: item.id,
              },
            });
            this.$store.commit("SETMENUSTATE", false);
          } else if (item.children.length === 0 && !item.url) {
            this.$router.push({
              name: item.name,
              params: {
                id: item.id,
              },
            });
          } else if (item.children.length > 0 && !item.url) {
            this.tabList[index].show=!this.tabList[index].show 
            if (this.tabList[index].show === true) {
              this.tabList.forEach((item, sub) => {
                if (sub !== index) {
                  this.tabList[sub].show = false;
                }
              });
            }
          }
        } else {
          if (item.url) {
            window.open(item.url, "_blank");
            this.$store.commit("SETMENUSTATE", false);
          } else {
            this.$router.push({
              name: item.name,
              params: {
                id: item.id,
              },
            });
            this.$store.commit("SETMENUSTATE", false);
          }
        }
      } else {
          //没有子节点时
        if (type === 1) {
          if (item.url) {
            this.$store.commit("SETMENUSTATE", false);
          } else if (item.children.length === 0 && !item.url) {
            this.$store.commit("SETMENUSTATE", false);
          } 
          else if (item.children.length > 0 && !item.url) {
            this.tabList[index].show=!this.tabList[index].show 
            if (this.tabList[index].show === true) {
              this.tabList.forEach((item, sub) => {
                if (sub !== index) {
                  this.tabList[sub].show = false;
                }
              });
            }
          }
        } else {
          this.$store.commit("SETMENUSTATE", false);
        }
      }
    },
  },
  watch: {
    $route(to, from) {
      if (to.name != "内容页") {
        this.pageName = to.name;
      } else {
        this.getNewsdetail();
      }
    },
  },
};
</script>
<style lang="less">
.global-menu {
  background-color: #126c92;
  width: 100vw;
  position: fixed;
  top: 62px;
  left: 0;
  height: calc(100% - 62px);
  z-index: 9999;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  align-content: center;
  margin-bottom: 80px;
  .global-menu-li {
    width: 100vw;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    line-height: 64px;
    .global-menu-li-title {
      // width: 64px;
      // height: 40px;
display:flex;
justify-content: center;
align-items:center;
      color: white;
    }
    .active{
      color:#03adf3;
    }
    .global-menu-li-many {
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      span {
      display: inline-block;
      }
    }
    .global-menu-li-drop {
      position: absolute;
      top: 27px;
      left: 70%;
      width: 16px;
      height: 10px;
    }
    .global-menu-li-list {
      width: 100%;
      color: white;
      background-color: #0B4C67;
    }
  }
  .global-menu-start {
    flex-direction: column;
  }
  .global-menu-bottom{
    width: 100vw;
    height: 70px;
    padding-bottom: 140px;
  }
}
</style>
